// Umami stores every address it is sent, so personal data never reaches it: the thank-you page's order token,
// the search query (kb-search records it once), customer and installation ids, and any email address.

const PRIVATE = /^(order|q|email|custid|iid)=|@|%40/i;

const withoutPrivateParams = (address) => address?.replace(/\?([^#]*)/, (_, query) => {
  const kept = query.split('&').filter(param => !PRIVATE.test(param));
  return kept.length ? `?${kept.join('&')}` : '';
});

// A page reached by a redirect carries its campaign in a meta tag, not in its address (Campaign on the server).
const withCampaign = (address) => {
  const campaign = document.querySelector('meta[name="campaign"]')?.content;
  if (!campaign || !address) return address;
  const url = new URL(address, window.location.href);
  new URLSearchParams(campaign).forEach((value, key) => url.searchParams.set(key, value));
  return url.toString();
};

window.cleanPayload = (_type, payload) => ({
  ...payload,
  url: withCampaign(withoutPrivateParams(payload.url)),
  referrer: withoutPrivateParams(payload.referrer),
});
